import { initializeApp } from 'firebase/app';
import { FIREBASE_API_KEY,FIREBASE_APP_ID,FIREBASE_AUTH_DOMAIN_KEY, FIREBASE_MEASUREMENTID, FIREBASE_MESSAGING_SENDERID, FIREBASE_PROJECTID, FIREBASE_STORAGE_BUCKET } from './config';

const firebaseConfig = {
    apiKey: FIREBASE_API_KEY,
    authDomain: FIREBASE_AUTH_DOMAIN_KEY,
    projectId: FIREBASE_PROJECTID,
    storageBucket: FIREBASE_STORAGE_BUCKET,
    messagingSenderId: FIREBASE_MESSAGING_SENDERID,
    appId: FIREBASE_APP_ID,
    measurementId: FIREBASE_MEASUREMENTID
};

const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;